/* eslint-disable max-len */
<template>
  <router-link :to="{ name: routeName }">
    <svg
      :width="width"
      :height="height"
      viewBox="0 0 128 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M45.5459 18.1065V22.8643H41.7664C38.2394 22.8643 36.0927 20.7349 36.0927
        17.2289V11.2794H33.1709V10.0104L40.3207
        2.49078H41.4485V7.09805H45.4589V11.2794H41.5879V16.2954C41.5879
        17.4268 42.2758 18.1065 43.4384 18.1065H45.5459Z"
        fill="#FFFFFF"
      />
      <path
        d="M58.5047 7.02489V11.9935H56.3711C54.4247 11.9935 53.6104 12.8367 53.6104
        14.8456V22.86H48.1152V7.09802H51.799L52.6568 8.84887C53.7802 7.56262 55.1519
        7.02489 57.0504 7.02489H58.5047Z"
        fill="#FFFFFF"
      />
      <path d="M60.5811 7.09801H66.0762V22.86H60.5811V7.09801Z" fill="#FFFFFF" />
      <path
        d="M85.3095 13.2497V22.86H79.8143V13.9982C79.8143 12.1613
        79.1176 11.2536 77.733 11.2536C76.0174 11.2536 75.0333 12.4366 75.0333
        14.4413V22.86H69.5381V7.09804H73.396L74.1493 8.72414C75.3381 7.41638
        77.1103 6.63345 79.1743 6.63345C82.8754 6.63345 85.3095 9.23176 85.3095 13.2497Z"
        fill="#FFFFFF"
      />
      <path d="M88.5928 7.09801H94.088V22.86H88.5928V7.09801Z" fill="#FFFFFF" />
      <path
        d="M108.31 18.1065V22.8643H104.53C101.003 22.8643 98.8563 20.7349 98.8563
        17.2289V11.2794H95.9346V10.0104L103.084
        2.49078H104.212V7.09805H108.223V11.2794H104.352V16.2954C104.352 17.4268 105.04 18.1065
        106.202 18.1065H108.31Z"
        fill="#FFFFFF"
      />
      <path
        d="M63.3291 5.11916C64.76 5.11916 65.92 3.97319 65.92 2.55957C65.92 1.14594 64.76
        -3.05176e-05 63.3291 -3.05176e-05C61.8982 -3.05176e-05 60.7383 1.14594 60.7383
        2.55957C60.7383 3.97319 61.8982 5.11916 63.3291 5.11916Z"
        fill="#FFFFFF"
      />
      <path
        d="M91.4277 5.11916C92.8586 5.11916 94.0186 3.97319 94.0186 2.55957C94.0186
        1.14594 92.8586 -3.05176e-05 91.4277 -3.05176e-05C89.9969 -3.05176e-05 88.8369
        1.14594 88.8369 2.55957C88.8369 3.97319 89.9969 5.11916 91.4277 5.11916Z"
        fill="#FFFFFF"
      />
      <path
        d="M106.215 29.4461C107.646 29.4461 108.806 28.3001 108.806 26.8865C108.806
        25.4728 107.646 24.3269 106.215 24.3269C104.784 24.3269 103.624 25.4728 103.624
        26.8865C103.624 28.3001 104.784 29.4461 106.215 29.4461Z"
        fill="#FFFFFF"
      />
      <path
        d="M128 7.08085H122.426L121.446 9.77811H121.442L118.577 17.6591L115.503
        9.77811H115.494L114.445 7.08515H108.862L110.09 9.77811H110.082L116.064
        22.903C115.389 24.684 114.815 25.1744 112.903 25.1744H111.532V29.4074H113.238C116.979
        29.4074 118.773 27.8243 120.724 23.4451L126.794 9.7738L128 7.08085Z"
        fill="#FFFFFF"
      />
      <path
        d="M24.9759 11.3913C24.9454 11.3913 24.9149 11.3913 24.8844 11.3913L8.12452
        11.2751V11.2794C7.49749 11.2493 6.86176 11.4687 6.38278 11.9376C5.47272 12.8281 5.46401
        14.2821 6.36972 15.1812C6.84434 15.6544 7.47137 15.8781 8.09404 15.8566L24.8626
        15.9727C25.4722 15.9899 26.0906 15.7706 26.5565 15.3103C27.4665 14.4198 27.4752
        12.9657 26.5695 12.0667C26.1254 11.6322 25.555 11.4085 24.9759 11.3913Z"
        fill="#FFFFFF"
      />
      <path
        d="M24.8493 5.7988L15.7705 5.73428C15.74 5.73428 15.7095 5.73428 15.6791
        5.73428C15.0999 5.74288 14.5252 5.96227 14.081 6.39676C13.171 7.28724
        13.1623 8.74126 14.068 9.64035C14.5034 10.0748 15.0738 10.2985 15.6486
        10.3157H15.6573C15.6878 10.3157 15.7183 10.3157 15.7487 10.3157L24.8798
        10.3803C25.4851 10.3889 26.0903 10.1695 26.5562 9.71778C27.4663 8.8273
        27.475 7.37328 26.5693 6.47419C26.0947 6.00529 25.4676 5.7816 24.8493 5.7988Z"
        fill="#FFFFFF"
      />
      <path
        d="M25.0457 16.9278H24.9717C24.9412 16.9278 24.9151 16.9278 24.8846
        16.9278L2.36389 16.7773C1.75864 16.7644 1.14903 16.9881 0.687467
        17.4398C-0.222592 18.3303 -0.2313 19.7843 0.674404 20.6834C1.14032
        21.148 1.75864 21.3717 2.3726 21.3588L24.8541 21.5093C24.8889
        21.5093 24.9194 21.5093 24.9543 21.5093H25.0152V21.505C25.5726
        21.4835 26.1256 21.2641 26.5523 20.8425C27.4624 19.952 27.4711
        18.498 26.5654 17.5989C26.143 17.1817 25.5987 16.9623 25.0457 16.9278Z"
        fill="#FFFFFF"
      />
    </svg>
  </router-link>
</template>

<script>
export default {
  name: 'LogoTrinityLight',
  props: {
    routeName: {
      type: String,
      default: 'Home',
    },
    width: {
      type: Number,
      default: 240,
    },
    height: {
      type: Number,
      default: 56,
    },
  },
};
</script>

<style>
</style>
